import { AppChat, type PadroesDto } from '@nexital/shared';
import { useDependencias } from '../../application/dependencias';
import { CampoConfig, Grupo, useCarga, useGravar } from './campos';

const CHATS = [
  { valor: AppChat.Whatsapp, rotulo: 'WhatsApp' },
  { valor: AppChat.Telegram, rotulo: 'Telegram' },
  { valor: AppChat.Teams, rotulo: 'Microsoft Teams' },
  { valor: AppChat.Slack, rotulo: 'Slack' },
];

const numero = (v: string) => (v === '' ? 0 : Number(v));

/** Padrões do sistema da empresa (ADR-0022): limites, prazos, avisos, inatividade e chat; só o administrador muda. */
export function SecaoPadroes() {
  const { configuracoes } = useDependencias();
  const { dados, erro, recarregar, definir } = useCarga(configuracoes.padroes);
  const { gravar, gravando } = useGravar();
  if (erro) return <p className="cartao-acesso__erro">{erro}</p>;
  if (!dados) return <p>Carregando…</p>;
  const campo = (k: keyof PadroesDto) => (v: string) => definir({ ...dados, [k]: k === 'orcamentoIaMensal' && v === '' ? null : numero(v) });
  const salvar = async () => {
    if (await gravar(() => configuracoes.salvarPadroes(dados), 'Padrões salvos.')) await recarregar();
  };
  return (
    <form
      className="config__formulario"
      onSubmit={(e) => {
        e.preventDefault();
        void salvar();
      }}
    >
      <Grupo titulo="Arquivos e prazos">
        <CampoConfig rotulo="Limite por arquivo (MB)" tipo="number" valor={dados.limiteArquivoMb} definir={campo('limiteArquivoMb')} largura="curta" />
        <CampoConfig rotulo="Prazo crítico (dias úteis)" tipo="number" valor={dados.diasPrazoCritico} definir={campo('diasPrazoCritico')} largura="curta" dica="Prazo a este número de dias úteis fica em vermelho." />
        <CampoConfig rotulo="Aviso de validade (dias)" tipo="number" valor={dados.diasAvisoValidade} definir={campo('diasAvisoValidade')} largura="curta" dica="Documentos da empresa vencendo neste prazo são avisados." />
      </Grupo>
      <Grupo titulo="Sessão e inteligência artificial">
        <CampoConfig rotulo="Sair por inatividade (minutos)" tipo="number" valor={dados.minutosInatividade} definir={campo('minutosInatividade')} largura="curta" />
        <CampoConfig rotulo="Orçamento mensal de IA (R$)" tipo="number" valor={dados.orcamentoIaMensal} definir={campo('orcamentoIaMensal')} largura="curta" dica="Em branco: sem limite." />
      </Grupo>
      <Grupo titulo="Aplicativo de mensagens da empresa">
        <label className="campo config__campo config__campo--media">
          <span>Aplicativo</span>
          <select value={dados.appChat ?? ''} onChange={(e) => definir({ ...dados, appChat: e.target.value ? (Number(e.target.value) as AppChat) : null })}>
            <option value="">Nenhum</option>
            {CHATS.map((c) => (
              <option key={c.valor} value={c.valor}>
                {c.rotulo}
              </option>
            ))}
          </select>
        </label>
      </Grupo>
      <div className="config__rodape">
        <button type="submit" className="botao botao--primario" disabled={gravando}>
          {gravando ? 'Salvando…' : 'Salvar'}
        </button>
      </div>
    </form>
  );
}
